"use strict";
/* eslint-disable functional/prefer-readonly-type */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOUpdateProductPrice = exports.mergeProductMaps = exports.updateProducts = exports.IOProducts = exports.initializeProducts = exports.updateProductPrice = exports.setProductsErrorAction = exports.updateProductsAction = void 0;
const isNotNil_1 = __importDefault(require("@simplisafe/ewok/ramda-adjunct/isNotNil"));
const monda_1 = require("@simplisafe/monda");
const fluture_1 = require("fluture");
const immutable_1 = require("immutable");
const monet_1 = require("monet");
const when_1 = __importDefault(require("ramda/src/when"));
const products_1 = require("../commercetools/products");
const query_1 = require("../commercetools/query");
const utils_1 = require("../redux/utils");
const errorLogging_1 = require("../thirdparty/errorLogging");
const utils_2 = require("./utils");
const updateProductsAction = (products) => ({
    '@@type': 'product',
    payload: products,
    type: 'UPDATE_PRODUCTS'
});
exports.updateProductsAction = updateProductsAction;
const setProductsErrorAction = (error) => ({
    '@@type': 'product',
    payload: monet_1.Maybe.fromUndefined(error),
    type: 'SET_PRODUCTS_ERROR'
});
exports.setProductsErrorAction = setProductsErrorAction;
const updateProductPrice = (product) => ({
    '@@type': 'product',
    payload: product,
    type: 'UPDATE_PRODUCT_PRICE'
});
exports.updateProductPrice = updateProductPrice;
/**
 * Sets products from a local payload.
 * Products should already be parsed using formatProductResponse.
 * This is for adding products to the front-end that are fetched during the build.
 *
 * @example
 * const dispatch = useDispatch()
 *
 * useEffect(() => {
 *   dispatch(initializeProducts(products))
 * }, [ dispatch, products ])
 */
const initializeProducts = (products) => ({
    '@@type': 'product',
    payload: products,
    type: 'SET_PRODUCTS'
});
exports.initializeProducts = initializeProducts;
/**
 * Fetches products from external source and populates Redux with results.
 * TODO: make this a redux-thunk action so it can be used as `dispatch(IOProducts())`
 * TODO: use locale from redux store instead of taking as argument
 *
 * @example
 * const dispatch = useDispatch()
 *
 * useEffect(() => {
 *   IOProducts(dispatch)('en-US')
 * }, [ dispatch ])
 */
const IOProducts = (dispatch) => (locale) => (0, products_1.commercetoolsRequestProducts)(locale)
    .pipe((0, fluture_1.map)(products_1.formatProductResponse))
    .pipe((0, fluture_1.fork)((e) => {
    (0, errorLogging_1.logError)(e);
    dispatch((0, exports.setProductsErrorAction)(e));
})((products => {
    products
        .cata(e => {
        (0, errorLogging_1.logError)(e);
        dispatch((0, exports.setProductsErrorAction)(e));
    }, p => dispatch((0, exports.updateProductsAction)(p)));
})));
exports.IOProducts = IOProducts;
/**
 *
 * Update existing products with any new values without adding any new products.
 * The products fetched during the build have child types filtered out,
 * and we don't want to add them back in.
 *
 */
const updateProducts = (oldProducts) => (newProducts) => (0, exports.mergeProductMaps)(oldProducts, newProducts);
exports.updateProducts = updateProducts;
/**
 * Merge two maps of products keyed by strings (presumably SKUs)
 *
 * This came about because Map.mergeDeep was choking on Maybe as a value
 * (eg "(TypeError): Expected [K, V] tuple")
 *
 * This function returns the first map with keys overwritten by the second map only if they're non-null values.
 * By design it does not, and should not, add new keys. As in doc for updateProducts, "products fetched during
 * build time have child types filtered out, and we don't want to add them back in."
 */
const mergeProductMaps = (originalProducts, newProducts) => (0, immutable_1.Map)((0, immutable_1.List)(originalProducts.entries())
    .reduce((acc, [key, val]) => ({
    ...acc,
    [key]: newProducts.has(key) && (0, isNotNil_1.default)(newProducts.get(key)) ? newProducts.get(key) : val
}), {}));
exports.mergeProductMaps = mergeProductMaps;
/**
 * Request a single product by key and returns the latest price info
 */
const IOUpdateProductPrice = (productKey) => (dispatch, getState) => {
    const state = getState();
    const lastFetched = (0, monda_1.safeProp)('products', state)
        .chain(products => (0, monda_1.safeProp)('value', products))
        .chain((value) => monet_1.Maybe.fromUndefined(value.get(productKey)))
        .chain(product => (0, monda_1.safeProp)('lastFetched', product))
        .getOrElse(0);
    const updatePrice = () => (0, query_1.commercetoolsRequestProductByKey)(productKey)
        .pipe((0, fluture_1.map)((val) => (0, query_1.parseProductQueryResponse)(productKey)(val)
        .map(utils_2.pickPriceDetails)))
        .pipe((0, fluture_1.fork)((e) => {
        (0, errorLogging_1.logError)(e);
        dispatch((0, exports.setProductsErrorAction)(e));
    })(product => {
        product.cata(e => {
            (0, errorLogging_1.logError)(e);
            dispatch((0, exports.setProductsErrorAction)(e));
        }, p => dispatch((0, exports.updateProductPrice)(p)));
    }));
    (0, when_1.default)(utils_1.shouldRefetch, updatePrice)(lastFetched);
};
exports.IOUpdateProductPrice = IOUpdateProductPrice;
//# sourceMappingURL=actions.js.map